/*
* HeroLib
*
* This lib provides procedures to handle common tasks surrounding the GOOD3
* heroes. Any component displaying heroes should probably add this mixin.
*/

// The LIBRARY
export const HeroLib = {
  data: () => ({

  }),
  methods: {
    // getPortraitImage returns the image name given hero information
    getPortraitImage (pHero) {
      let vGender = pHero.gender === 'M' ? 'male' : 'female'
      return 'hero_portrait_' + pHero.hero_class + '_' + vGender + '.png'
    }
  }
}
